import { RecoveryPVIRadius, RecoveryPVISource } from "constants/charts.enums";

const METRICS = ["Porosity", "OriginalVolumeConstrained_ha_m", "OOIP"];

const SOURCE_SUFFIX: Record<RecoveryPVISource, string> = {
  [RecoveryPVISource.AllSources]: "All",
  [RecoveryPVISource.Private]: "Private",
  [RecoveryPVISource.EvaResearch]: "Default"
};

const RADIUS_PREFIX: Record<RecoveryPVIRadius, string> = {
  [RecoveryPVIRadius.Gross]: "ThreedvGross",
  [RecoveryPVIRadius.SweetSpot]: "ThreedvSweetSpot",
  [RecoveryPVIRadius.LandingZone]: "ThreedvLandingZone"
};

export function getRecoveryPVIFields(
  radius: RecoveryPVIRadius,
  source: RecoveryPVISource
): string[] {
  const prefix = RADIUS_PREFIX[radius];
  const suffix = SOURCE_SUFFIX[source];
  return METRICS.map((metric) => `${prefix}.${metric}_${suffix}`);
}
